export class SmartInterval {
    private serviceCall: () => any;
    private intervalMs: number;
    private intervalName: string;
    private acknowledgmentDelayMsBeforePausing: number;
    private pauseCallbackFunction: (arg0: any) => any;
    private lastAck: number;
    private isPaused = false;
    private isCancelled = false;
    private ackIntervalId: any;
    private funcCallIntervalId: any;

    constructor(
        serviceCall: () => any,
        intervalMs: number,
        intervalName: string = 'Unnamed',
        acknowledgmentDelayMsBeforePausing: number,
        pauseCallbackFunction?: (arg0: any) => any,
    ) {
        this.serviceCall = serviceCall;
        this.intervalMs = intervalMs;
        this.intervalName = intervalName;
        this.acknowledgmentDelayMsBeforePausing = acknowledgmentDelayMsBeforePausing;
        this.pauseCallbackFunction = pauseCallbackFunction;
        this.lastAck = Date.now();
        const checkForAckMs = acknowledgmentDelayMsBeforePausing / 2 + 1;
        if (intervalMs && intervalMs > 0) {
            console.log('Starting interval');
            this.ackIntervalId = setInterval(this.checkForAck.bind(this), checkForAckMs);
            this.run();
        } else {
            console.log('Interval not started, intervalMs=', intervalMs, 'should be greater than 0.');
        }
    }

    private run(): void {
        if (this.isPaused === false && this.isCancelled === false) {
            console.log('Running interval');
            this.funcCallIntervalId = setInterval(this.serviceCall.bind(this), this.intervalMs);
        }
    }

    public sendHeartbeat(): void {
        if (this.isCancelled) {
            console.warn('Tried to restart cancelled interval.');
        }
        if (this.isPaused) {
            console.log('Restarting interval');
            this.isPaused = false;
            this.run();
        }
        this.lastAck = Date.now();
    }

    public cancel(): void {
        console.log('Cancelling interval.');
        this.pause();
        this.isCancelled = true;
        clearInterval(this.ackIntervalId);
    }

    private checkForAck(): void {
        const ackDiff = Date.now() - this.lastAck;
        if (!this.isPaused && ackDiff > this.acknowledgmentDelayMsBeforePausing) {
            console.warn('Pausing interval since last ACK was received', ackDiff, 'ms ago.');
            this.pause();
            if (this.pauseCallbackFunction) {
                this.pauseCallbackFunction({
                    intervalName: this.intervalName,
                });
            }
        }
    }

    private pause(): void {
        this.isPaused = true;
        clearInterval(this.funcCallIntervalId);
    }
}
